import { FintechPapiEmployee, FintechPapiJob } from 'src/api/interfaces';

export interface ProfileInfo {
  jobTitle?: string;
  jobLevel?: string;
  city?: string;
  buildingCode?: string;
  badgeColor?: string;
}

/** Maps PAPI badge color names to hex values (matching baseball card conventions) */
export const BADGE_COLOR_MAP: Record<string, string> = {
  blue: '#0073bb',
  green: '#1d8102',
  yellow: '#f2a900',
  orange: '#f2a900',
  red: '#d13212'
};

/** Maps a PAPI employee response to the ProfileInfo shape used by the profile UI. */
export function mapEmployeeToProfileInfo(employee: FintechPapiEmployee): ProfileInfo {
  return {
    jobTitle: (employee.job as FintechPapiJob)?.businessTitle || employee.basicInfo?.businessTitle,
    jobLevel: employee.job?.jobLevel,
    city: employee.workLocation?.city,
    buildingCode: employee.workLocation?.buildingCode,
    badgeColor: employee.basicInfo?.badgeColor
  };
}
